import React, { useEffect, useRef, useState } from "react";
import "./filterBox.css";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";

const FilterBox = ({ setFilter, filter, togglePopup }) => {
  // calnder icon click acedmec session
  const startDatePickerRef = useRef(null);
  const teacherInformation = useSelector(
    (state) => state.user.currentUser?.subject_information
  );

  const [subjectsData, setSubjectsData] = useState([]);
  useEffect(() => {
    let subjectsList = [];
    const getSubjects = () => {
      if (teacherInformation) {
        subjectsList = [...teacherInformation];
      }
    };
    getSubjects();
    setSubjectsData(subjectsList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teacherInformation]);

  const handleStartDateClick = () => {
    startDatePickerRef.current.setOpen(true);
  };
  const [selectedDate, setSelectedDate] = useState(filter.date);
  const [selectedTime, setSelectedTime] = useState();

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const [subjectList, setSubjectList] = useState([]);
  const handleOptionChange = (event) => {
    const optionId = event.target.value;
    if (event.target.checked) {
      setSubjectList([...subjectList, optionId]);
    } else {
      setSubjectList(subjectList.filter((id) => id !== optionId));
    }
  };

  const handleTimeClick = (event) => {
    const data = event.target.value;
    setSelectedTime(data);
  };
  const PreReadbtns = document.querySelectorAll(".timeButton");
  PreReadbtns.forEach((btnElCM) => {
    btnElCM.addEventListener("click", () => {
      document.querySelector(".focusbtns1")?.classList.remove("focusbtns1");
      btnElCM.classList.add("focusbtns1");
    });
  });

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: "42px",
          right: "0px",
          backgroundColor: "white",
          width: "400px",
          border: "2px solid #F99933",
          borderRadius: "5px",
          height: "fitContent",
        }}
      >
        <div className="filterbox d-flex">
          <img src="/images/filter_sel.svg" />
          <h5 className="mb-2 filter_Text">Filter</h5>
        </div>
        <div className="py-2 d-flex">
          <div className="col-5 filter_subj_box">
            <h5 className="mb-2 filter_first_heading_ass">SUBJECT</h5>
            <div className=" gap-2 px-3 d-flex align-item-center flex-column subject_subbox  ">
              {subjectsData?.length >= 0 &&
                subjectsData?.map((subject, index) => (
                  <div key={index} className="d-flex align-items-center">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id={subject.id}
                      name={subject.name}
                      value={subject.id}
                      onChange={handleOptionChange}
                      checked={
                        filter.subjectId.includes(subject?.id) ||
                        subjectList.includes(subject?.id)
                      }
                    />
                    &nbsp;
                    <span style={{ marginTop: "3px" }}>{subject?.name}</span>
                  </div>
                ))}
            </div>
          </div>
          <div className="col-7 p-0 filter_time_box">
            <h5 className="mb-2 filter_first_heading_ass">TIME</h5>
            <div className="col-12 d-flex justify-content-between filter_both_column">
              <div className="col-6 d-flex gap-2 flex-column p-0 subject_subBox">
                <button
                  value="today"
                  onClick={handleTimeClick}
                  className={`${filter.time === "today" && "focusbtns1"
                    } timeButton`}
                >
                  Today
                </button>
                {/*  */}
                <button
                  value="thisweek"
                  onClick={handleTimeClick}
                  className={`${filter.time === "thisweek" && "focusbtns1"
                    } timeButton`}
                >
                  This Week
                </button>
                <button
                  value="thismonth"
                  onClick={handleTimeClick}
                  className={`${filter.time === "thismonth" && "focusbtns1"
                    } timeButton`}
                >
                  This Month
                </button>
              </div>
              <div className="col-5 d-flex gap-2  flex-column p-0 subject_subBox">
                <button
                  value="yesterday"
                  onClick={handleTimeClick}
                  className={`${filter.time === "yesterday" && "focusbtns1"
                    } timeButton`}
                >
                  Yesterday
                </button>
                <button
                  value="lastweek"
                  onClick={handleTimeClick}
                  className={`${filter.time === "lastweek" && "focusbtns1"
                    } timeButton`}
                >
                  Last Week
                </button>
                <button
                  value="lastmonth"
                  onClick={handleTimeClick}
                  className={`${filter.time === "lastmonth" && "focusbtns1"
                    } timeButton`}
                >
                  Last Month
                </button>
              </div>
            </div>
            <h5 className="mt-2 filter_first_heading_ass">Pick A Date</h5>

            <div className="ml-3">
              <div className="d-flex  justify-content-between  filter_date_picker">
                <div>
                  <DatePicker
                    ref={startDatePickerRef}
                    selected={selectedDate}
                    onChange={handleDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="SelectDate"
                    placeholderText="DD:MM:YYYY"
                    value={filter.date || selectedDate}
                  />
                </div>
                <div>
                  <img
                    src="/HwImg/FilterCalender.png"
                    alt="calendar Icon"
                    className="calenderIcon"
                    onClick={handleStartDateClick}
                  />
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end mr-2 mt-2 gap-2">
              <button
                className="clearBtn2"
                onClick={() => {
                  setFilter((prev) => ({
                    ...prev,
                    subjectId: [],
                    time: null,
                    date: null,
                  }));
                  togglePopup();
                  setSubjectList([]);
                  setSelectedDate("");
                  setSelectedTime("");
                  document
                    .querySelector(".focusbtns1")
                    ?.classList.remove("focusbtns1");
                }}
              >
                Clear
              </button>
              <button
                className="applyBtn"
                onClick={() => {
                  setFilter((prev) => ({
                    ...prev,
                    subjectId: subjectList,
                    time: selectedTime,
                    date: selectedDate,
                  }));
                  togglePopup();
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterBox;
